// Added for handling the material-ui bug discussed in https://hopchat.slack.com/archives/C011BJV2B8F/p1615477397022400
// <Slack-Context: #dev-web from @Steve Shen on 2021-03-11> <!subteam^S01H0PZAT6D> @Leonard @Kevin hey - while working
//  on https://hopper-jira.atlassian.net/browse/BP-432 (fixing broken header
//  on https://b2bportal.app-development.h4r.io/basicAuth/id=H0PPER/pwd=6unnies), it seems to me that the cleanest way
//  to fix it is by upgrading material-ui from v4 to v5 (see https://github.com/mui-org/material-ui/issues/17370).
//  However, given that v5 isn't very stable yet and "the only downside of v5 is that there are more breaking changes
//  coming", I don't know if that's a risk we are ready to take just yet. Since we are still at a stage where we need to
//  deliver things fast, introducing material-ui v5 could cause unexpected bugs that we will have to handle. In my
//  opinion, we might want to wait till we have a solid QA who can give us testing feedbacks before attempting this
//  upgrade. Also, upgrading it on Halifax will force `Nuuk` to upgrade it as well, so I wanted to ask you guys about
//  your thoughts.
// </Slack-Context>
export const removeStyleSheetByMetaName = (metaName: string) => {
  Array.from(document.querySelectorAll("style")).forEach((element) => {
    try {
      if (element.dataset["meta"] === metaName) {
        element.parentNode?.removeChild(element);
      }
    } catch (err) {
      console.log(`Failed to remove ${metaName} stylesheet.`);
    }
  });
};
